import {Button, Stack} from '@mui/material';
import React, {Fragment} from 'react';

import {AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {InfoSubscriptionDialogProps} from './types';
import {StyledDescription} from './styles';
import {BillsTaggingEnum} from 'main/analytics/gaTagsEnum';

const {infoSubscriptionDialog} = translations['pt-br'].privateFlow.myFinancial.openBills;

function InfoSubscriptionDialog({
	onPrimaryAction,
	open,
	email,
	onClose,
	isBemobiFlow = false,
}: InfoSubscriptionDialogProps) {
	const line1 = isBemobiFlow ? infoSubscriptionDialog.line1Bemobi : infoSubscriptionDialog.line1;

	return (
		<AlertModal
			headerDataTagId={BillsTaggingEnum.VISUALIZOU_MODAL_SAIBA_MAIS_ADESAO_BOLETO}
			closeBtnDataTagId={BillsTaggingEnum.CLICK_FECHAR_MODAL_SAIBA_MAIS_ADESAO_BOLETO}
			variant="primary"
			customIconName="info-filled"
			headerTitle={infoSubscriptionDialog.header}
			open={open}
			onClose={onClose}
			subDescription={
				<Fragment>
					<StyledDescription>
						{line1}
						<b>{email}</b>
						{infoSubscriptionDialog.line2}
					</StyledDescription>
					<StyledDescription>{infoSubscriptionDialog.line3}</StyledDescription>
				</Fragment>
			}
			footerContent={
				<Stack gap={1} width="100%">
					<Button
						type="submit"
						size="large"
						data-test="confirm-new-contact"
						data-tag-id={BillsTaggingEnum.CLICK_ENTENDI_MODAL_SAIBA_MAIS_ADESAO_BOLETO}
						onClick={onPrimaryAction}
						fullWidth>
						{infoSubscriptionDialog.confirmButton}
					</Button>
				</Stack>
			}
		/>
	);
}

export {InfoSubscriptionDialog};
